import { SiOpenaigym } from "react-icons/si";

export const links = [
{
    name: "Home",
    path: '/',
},
{
    name: "About",
    path: '/about',
},
{
    name: "Pricing",
    path: '/pricing'
},
{
    name: "Contact",
    path: '/contact'
},
{
  name: "My Bookings",
  path: '/my-bookings'
},
{ name: "Videos",
  path: "/videos" 
}
]

const IPImage = require('./images/1799_Central_Ave.png')
const OLImage = require('./images/online.png')
export const classes = [
{
    id: 1,
    icon: <SiOpenaigym/>,
    image: IPImage,
    title: "In Studio",
    description: "For the first time since the pandemic, we're having in-person classes 3 times a week at 'Soley Massage and Wellness'.", 
    path: "/programs/1"
},
{
    id: 2,
    icon: <SiOpenaigym/>,
    image: OLImage,
    title: "Online",
    description: "Every weekend, the regular classes that got you through the pandemic are continuing to help you ignite your home practice. Join us online.", 
    path: "/programs/2"
}
// ,
// {
//     id: 3,
//     icon: <SiOpenaigym/>,
//     title: "Yoga Lab",
//     description: "Coming soon! 2 hour in person class curated by you. Send in you questions on asana, pranayama or yogic philosophy before hand and we'll unravel the mysteries together.", 
//     path: "/programs/3"
// }
// ,
// {
//     id: 4,
//     icon: <SiOpenaigym/>,
//     title: "Advanced",
//     description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.", 
//     path: "/programs/4"
// }
]

// const YLImage = require('./images/halasana__.jpg')

export const classDetails = [
{
    id: 1,
    img: IPImage,
    title: "In Studio",
    description: "For the first time since the pandemic, we're having in-person classes 3 times a week at 'Journey into Fitness' on Central Avenue. Monday 10am, Wednesday at 5:30pm and Friday 10am. Monday and Friday classes are 1.5 hours long. Wednesday evening is 1.25hrs. Please bring your own mat, belt and 2 bricks. To be able to practice shoulder stand, 4-6 blankets are recommended, alternatives asana are offered.",
    path: "https://duckduckgo.com/?t=ffab&q=1799+central+ave+st+pete+fl&atb=v373-1&iaxm=directions&source=directions&end=2963+46th+Ave+N%2C+Saint+Petersburg%2C+FL++33714%2C+United+States&transport=automobile",
    location: [
        'Soley Massage', '2963 46th Ave N', 'St. Petersburg', 'FL 33714'
        ]
    // image: require('./images/programs-1.png'),  
},
{
    id: 2,
    img: OLImage,
    title: "Online",
    description: "Every weekend, the regular classes that got you through the pandemic are continuing to help you ignite your home practice. Join us online. Saturday and Sunday mornings at 9am. 1.25hrs. Please bring your own mat, belt and 2 bricks. To be able to practice shoulder stand, 4-6 blankets are recommended, alternatives asana are offered.",
    path: "/",
    location: [
        "you'll be sent a link when you sign up for class",
    ]
    // image: require('./images/programs-2.png'),
}
// ,
// {
//     id: 3,
//     img: YLImage,
//     title: "Yoga Lab",
//     description: "Coming soon! 2 hour in person class curated by you. Send in you questions on asana, pranayama or yogic philosophy before hand and we'll unravel the mysteries together.",
//     path: "/",
//     location: [
//         "we'll let you know when we're ready to start"
//     ]
//     // image: require('./images/programs-3.png'),
// }
]

export const values = [
{
    id: 2,
    icon: <SiOpenaigym/>,
    title: "Class Passes",
    description: "Class passes are ideal way of saving money and giving an intention of class attendance. Each pass is available for use for up to 8-weeks for 4-class pass & 3-months for the 8-class pass, for both in-person and online classes.",
    path: "/"
},
{
    id: 3,
    icon: <SiOpenaigym/>,
    title: "Subscriptions",
    description: "Subscriptions are for those who are committed to practice, and are the cheapest way to practice with us. Available for 2x classes per week and unlimited attendance, for both in-person and online classes.",
    path: "/"
},
{
    id: 4,
    icon: <SiOpenaigym/>,
    title: "Drop-in Classes",
    description: "Drop-in classes are available in-person and online. It's the same great class you've come to love, just pay as you go.",
    path: "/"
},
// {
//     id: 4,
//     icon: <SiOpenaigym/>,
//     title: "2-classes/week",
//     description: "This is a rolling monthly contract, a minimum 3-months commitment that gives you to access 2 classes per week, both online and in-person.",
//     path: "/pricing"
// },
// {
//     id: 5,
//     icon: <SiOpenaigym/>,
//     title: "Unlimited Classes",
//     description: "This is a rolling monthly contract, a minimum 6-months commitment that gives you to access as many classes per week as you can attend, both online and in-person.",
//     path: "/pricing"
// },
{
    id: 6,
    icon: <SiOpenaigym/>,
    title: "New Student Special - locals only",
    description: "This 3-class pass is available for you to use for up to 2-weeks, for both in-person and online classes.",
    path: "mailto:info@iy-sp.com"
}
]


// const Teacher1 = require('./images/teacher-1.png')
const Teacher2 = require('./images/teacher-2.png')

export const teachers = [
    // {
    //     id: 1, 
    //     image: Teacher1,
    //     name: "Susan Marcus",
    //     title: "Licensed Yoga Therapist",
    //     bio: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    //     socials: [ 
    //         'https://www.instagram.com/', 'https://www.twitter.com/', 'https://www.facebook.com/','https://www.linkedin.com/'
    //     ]
    // },
    {
        id: 2,
        image: Teacher2,
        name: "Tricia Amheiser",
        title: "CIYT, C-IAYT",
        bio: [
            "Tricia has been practicing yoga since the mid-nineties, began her practice of Iyengar Yoga in 2002 and became a certified Iyengar Yoga teacher (CIYT) in 2010 in the UK. After establishing her home in the USA, she has continued the vigorous process of of training and assessment, achieving Intermediate Junior II in August 2016. She has also been fortunate to have attained certification by International Association of Yoga Therapists, IAYT a well respected & world renown organization in the field of yoga therapeutics.",
        
            "Tricia is the director and owner of the fully equipped Iyengar Yoga Studio - \"Iyengar Yoga St. Petersburg\" in Florida. Tricia has studied at the Institute in Pune, under Geetaji and Prashantji Iyengar and also in Bangalore where renown Iyengar yoga teacher and dutiful student of the Iyengars, Arun Bhat has his yoga school.",

            "She recently participated as an instructor and co-author of a pilot study of Iyengar yoga for Aromatase Inhibitor-associated Joint Pain in Women recovering from breast cancer, conducted at the Moffitt Cancer Center in Tampa, FL.",
    ],
        socials: [ 
            'https://www.instagram.com/', 'https://www.bluesky.com/', 'https://www.facebook.com/','https://www.linkedin.com/'
        ]
    }
]

export const testimonials = [
    {
        id: 0,
        name: "John Doe",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        occupation: "Web Developer",
        avatar: require("./images/avatar-1.png")
    },
    {
        id: 1,
        name: "Jane Doe",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        occupation: "Designer",
        avatar: require("./images/avatar-5.png")
    },
    {
        id: 2,
        name: "Jill Doe",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        occupation: "student",
        avatar: require("./images/avatar-2.png")
    },
    {
        id: 3,
        name: "John Smith",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        occupation: "Photographer",
        avatar: require("./images/avatar-4.png")
    },
    {
        id: 4,
        name: "Jane Smith",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        occupation: "Artist",
        avatar: require("./images/avatar-3.png")
    },
    {
        id: 5,
        name: "John Martin",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        occupation: "student",
        avatar: require("./images/avatar-1.png")
    },
    {
        id: 6,
        name: "Marianne Williams",
        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        occupation: "grifter",
        avatar: require("./images/avatar-5.png")
    }
]
export const aboutStory = [
  {
    id: 1,
    title: "About Iyengar Yoga",
    paragraphs: [
      "Iyengar Yoga, developed by B.K.S. Iyengar, is a form of Hatha Yoga distinguished by its emphasis on precision, alignment, and sequencing. This method approaches yoga as both an art and a science, focusing on structural alignment within each posture to cultivate strength, flexibility, stability, and awareness. What sets Iyengar Yoga apart is its use of props—blocks, belts, blankets, and chairs—which make the practice accessible to everyone regardless of age, physical condition, or experience level.",
      "At its heart, Iyengar Yoga is a transformative journey that extends far beyond physical exercise. As B.K.S. Iyengar explained in his teachings, this practice integrates body, mind, and spirit, bringing harmony to our entire being. Through dedicated practice, students develop not only physical well-being but also mental clarity, emotional stability, and spiritual growth.",
    ],
  },
  {
    id: 2,
    title: "Iyengar Yoga St Pete",
    paragraphs: [
      "Iyengar Yoga St. Petersburg was established in 2016 by Tricia Amheiser, developing the studio with a commitment to sharing the authentic teachings of B.K.S. Iyengar with the local community. The studio grew steadily, providing an ideal environment for students to develop their practice with proper attention to detail and technique. Though the physical studio temporarily closed during the pandemic, the strong foundation of Iyengar principles helped sustain the community through this challenging period.",
    ],
  },
  {
    id: 3,
    title: "New Mission",
    paragraphs: [
      "We are excited to have in-person classes every Friday, 10am at \"Soley Therapeutic Massage\" on 46th Ave N in St. Petersburg.",
      "Looking ahead, we're planning to include more specialized workshops focusing on poses that you've never tried but would like to & more therapeutic applications from simple ailments to more complex destabilizing conditions. We have our ears open to our student body and their needs.",
      "Iyengar Yoga St. Petersburg remains committed to B.K.S. Iyengar's legacy of making yoga's transformative benefits accessible to practitioners of St Petersburg and beyond.",
    ],
  },
]
export const faqs =[
    {
        id: 1,
        question: "What is the difference between Iyengar yoga and other styles of yoga?",
        answer: "Iyengar Yoga, developed by B.K.S. Iyengar, is a form of Hatha Yoga distinguished by its emphasis on precision, sequencing and inclusion of inversions; head stand - Salamba Sirsasana, shoulder stand - Salamba Sarvangasana, etc. This method approaches yoga as both an art and a science, focusing on structural alignment within each posture to cultivate strength, flexibility,        stability, and awareness. It's also known for its use of props and offering alternative poses & modifications of poses to make the practice accessible to all body types and abilities."
    },
    {
        id: 2,
        question: "What should I bring to class?",
        answer: "For in-person classes, you can bring your own mat, a bolster, we have some limited props available. We have enough blankets for 5 people to do shoulder stand comfortably. As always, alternative poses are offered."
    },
    {
        id: 3,
        question: "How many classes can I attend per week?",
        answer: "You can attend as many or as few as you would like. We recommend that you aim for two classes a week to affect the change you may be after."
    },
    {
        id: 4,
        question: "What are the benefits of yoga?",
        answer: "At its heart, Yoga is a transformative journey that extends far beyond physical exercise. As B.K.S. Iyengar explained in his teachings, this practice integrates body, mind, and spirit, bringing harmony to our entire being. Through dedicated practice, students develop not only physical well-being but also mental clarity, emotional stability, and spiritual growth."
    },
    {
        id: 5,
        question: "Will yoga help cure my back pain?",
        answer: "Not all back pain is curable with stability and flexibility postural exercises, but most are. We do offer specialist class series from time to time that will help you manage various minor conditions. We'll keep you posted as to when they will be offered."
    },
    {
        id: 6,
        question: "What is the minimum age requirement to join?",
        answer: "We don't currently teach children's classes, young adults, adults of all ages are welcome."
    }
]

//\/\/\/\/\/\/\/\/\/\/\/\/\ old data \/\/\/\/\/\/\/\/\/\/\/\/\
export const pricing = [

{
    id: 1,
    title: "4-class pass",
    description: "multi-class price",
    price: 84.00,
    features: [
        // {feature: 'single class', available: true}, //single class //
        //{feature: '1hr class', available: false}, //1hr class //
        {feature: '1.25hr class', available: true}, //1hr class //
        {feature: '1.5 hrs', available: true}, //1.5 hrs //
        // {feature: '2 hrs', available: true}, //2 hrs //
        {feature: 'private class', available: false}, //private class //
        {feature: 'group class', available: true}, //group class //
        {feature: 'therapy class ', available: true}, //therapy class //
        {feature: 'renews monthly', available: false}, //renews monthly //
        {feature: '2x classes/week ', available: false}, //2x classes/week //
        {feature: 'unlimited', available: false}, //unlimited // 
        {feature: 'free access to recorded classes', available: false}, //unlimited // 
        {feature: 'contract signed', available: false} //contract signed//         
    ],
    path: '/'
},
{
    id: 2,
    title: "8-class pass",
    description: "multi-class price",
    price: 152.00,
    features: [
        // {feature: 'single class', available: false}, //single class //
       // {feature: '1hr class', available: false}, //1hr class //
        {feature: '1.25hr class', available: true}, //1hr class //
        {feature: '1.5hr class', available: true}, //1.5 hrs //
        // {feature: '2 hr class', available: true}, //2 hrs //
        {feature: 'private class', available: false}, //private class //
        {feature: 'group class', available: true}, //group class //
        {feature: 'therapy class', available: true}, //therapy class //
        {feature: 'renews monthly ', available: false}, //renews monthly //
        {feature: '2x classes/week', available: false}, //2x classes/week //
        {feature: 'unlimited', available: false}, //unlimited // 
        {feature: 'free access to recorded classes', available: false}, //unlimited // 
        {feature: 'contract signed', available: false} //contract signed//         
    ],
    path: '/'
},
{
    id: 3,
    title: "Committed",
    description: "multi-class price (2/week)",
    price: 129.00,
    features: [
        // {feature: 'single class', available: false}, //single class //
      //  {feature: '1hr class', available: false}, //1hr class //
        {feature: '1.25hr class', available: true}, //1hr class //
        {feature: '1.5hr class', available: true}, //1.5 hrs //
        // {feature: '2 hr class', available: true}, //2 hrs //
        {feature: 'private class', available: false}, //private class //
        {feature: 'group class', available: true}, //group class //
        {feature: 'therapy class', available: true}, //therapy class //
        {feature: 'renews monthly ', available: true}, //renews monthly //
        {feature: '2x classes/week', available: true}, //2x classes/week //
        {feature: 'unlimited', available: false}, //unlimited // 
        {feature: 'free access to recorded classes', available: true}, //unlimited // 
        {feature: 'contract signed', available: true} //contract signed/
    ],
    path: '/'
},
{
    id: 4,
    title: "Monthly",
    description: "multi-class price (unlimited)",
    price: 169.00,
    features: [
        // {feature: 'single class', available: false}, //single class //
       // {feature: '1hr class', available: false}, //1hr class //
        {feature: '1.25hr class', available: true}, //1hr class //
        {feature: '1.5hr class', available: true}, //1.5 hrs //
        // {feature: '2 hr class', available: true}, //2 hrs //
        {feature: 'private class', available: false}, //private class //
        {feature: 'group class', available: true}, //group class //
        {feature: 'therapy class', available: true}, //therapy class //
        {feature: 'renews monthly ', available: true}, //renews monthly //
        {feature: '2x classes/week', available: false}, //2x classes/week //
        {feature: 'unlimited', available: true},
        {feature: 'free access to recorded classes', available: true}, //unlimited // 
        {feature: 'contract signed', available: true} //contract signed/ 
    ],
    path: '/'
}
]

// ,
// {
//     id: 5,
//     title: "New Student Special",
//     description: "3 classes, expires in 2 weeks",
//     price: 36.00,
//     features: [
//         // {feature: 'single class', available: false}, //single class //
//        // {feature: '1hr class', available: false}, //1hr class //
//         {feature: '1.25hr class', available: true}, //1hr class //
//         {feature: '1.5hr class', available: true}, //1.5 hrs //
//         // {feature: '2 hr class', available: true}, //2 hrs //
//         {feature: 'private class', available: false}, //private class //
//         {feature: 'group class', available: true}, //group class //
//         {feature: 'therapy class', available: false}, //therapy class //
//         {feature: 'renews monthly ', available: false}, //renews monthly //
//         {feature: '2x classes/week', available: false}, //2x classes/week //
//         {feature: 'unlimited', available: false}, //unlimited // 
//         {feature: 'free access to recorded classes', available: false}, //unlimited // 
//         {feature: 'contract signed', available: false} //contract signed/ 
//     ]
// },


// export const weekdays = [
//     {
//         id: 1,
//         day: 'Sunday'
//     },
//     {
//         id: 2,
//         day: 'Monday'
//     },
//     {
//         id: 3,
//         day: 'Tuesday'
//     },
//     {
//         id: 4,
//         day: 'Wednesday'
//     },
//     {
//         id: 5,
//         day: 'Thursday'
//     },
//     {
//         id: 6,
//         day: 'Friday'
//     },
//     {
//         id: 7,
//         day: 'Saturday'    
//     }

// ]

//^^^^^^^^^^^ old ^^^^^^^^^^^^

//------------------- scheduling ---------------------- //
// export const teach = [
//   { id: "teacher_001", 
//     name: "Tricia", 
//     bio: "...", 
//     image: "Tricia.jpg" }
// ];

// export const event = [
//   {
//     id: "class_001",
//     title: "Morning",
//     teacher: "teacher_001",
//     date: "2026-05-05",
//     time: "09:00",
//     duration: 90,
//     venue: "venue_001",
//     spotsTotal: 12,
//     spotsRemaining: 8,
//     passType: "yoga",
//     price: 20
//   }
// ];

// export const staff = [
//   { name: "Tricia", payRate: 15 },
//   { name: "Staff_1", payRate: 6 },
//   { name: "Staff_2", payRate: 8 },
// ];

// export const passTypes = [
//   { id: "single", name: "Single Class", classes: 1, price: 25 },
//   { id: "four_pack", name: "4 Class Pack", classes: 4, price: 84 },
//   { id: "eight_pack", name: "8 Class Pack", classes: 8, price: 152 },
//   { id: "2xWeek", name: "Twice a week", classes: null, price: 129 },
//   { id: "monthly", name: "Monthly Unlimited", classes: null, price: 169 }
// ];

// // ─── VENUES ───────────────────────────────────────────────
export const venues = [
  {
    id: "venue_001",
    name: "Soley Massage and Wellness",
    address: "2963 46th Ave N, St. Petersburg, FL 33714",
    mapPath: "https://duckduckgo.com/?t=ffab&q=2963+46th+Ave+N+St+Petersburg+FL&atb=v373-1&iaxm=directions"
  },
  {
    id: "venue_online",
    name: "Online",
    address: null,
    mapPath: null
  },
  { id: "venue_002", 
    name: "Other Venue", 
    address: "123 Main St, St. Petersburg, FL" 
}
]

// ─── SCHEDULE ─────────────────────────────────────────────
// Recurring weekly classes — dates auto-generated by the calendar component
// export const recurringClasses = [
//   {
//     id: "cls_mon",
//     title: "Iyengar Yoga",
//     teacher: "Tricia Amheiser",
//     dayOfWeek: 1,        // 0=Sun, 1=Mon ... 6=Sat
//     time: "10:00",
//     duration: 90,
//     venue: "venue_001",
//     spotsTotal: 12,
//     price: 25.00,
//     passEligible: true
//   },
//   {
//     id: "cls_wed",
//     title: "Iyengar Yoga",
//     teacher: "Tricia Amheiser",
//     dayOfWeek: 3,
//     time: "18:00",
//     duration: 75,
//     venue: "venue_001",
//     spotsTotal: 12,
//     price: 25.00,
//     passEligible: true
//   },
//   {
//     id: "cls_fri",
//     title: "Iyengar Yoga",
//     teacher: "Tricia Amheiser",
//     dayOfWeek: 5,
//     time: "10:00",
//     duration: 90,
//     venue: "venue_001",
//     spotsTotal: 12,
//     price: 25.00,
//     passEligible: true
//   },
//   {
//     id: "cls_sat",
//     title: "Iyengar Yoga — Online",
//     teacher: "Tricia Amheiser",
//     dayOfWeek: 6,
//     time: "08:15",
//     duration: 90,
//     venue: "venue_online",
//     spotsTotal: 20,
//     price: 25.00,
//     passEligible: true
//   },
//   {
//     id: "cls_sun",
//     title: "Iyengar Yoga — Online",
//     teacher: "Tricia Amheiser",
//     dayOfWeek: 0,
//     time: "10:00",
//     duration: 90,
//     venue: "venue_online",
//     spotsTotal: 20,
//     price: 25.00,
//     passEligible: true
//   }
// ]

export const footerLinks = [
    {   
        id: 1,
        name: "pre-therapy questionnaire",
        path: "/forms/intake"
    },
    {   
        id: 2,
        name: "pre-session form",
        path: "/forms/pre-session"
    },
    {
        id: 3,
        name: "post-session form",
        path: "/forms/post-session"
    },
    {
        id: 4,
        name: "case study consent",
        path: "/forms/therapy-intensive-consent"
    },
]

